import type { FC, ReactNode } from 'react'

import { Container } from '@/components/generals/container'
import { CLIENTS } from '@/constants/content'

export const ClientsMarquee: FC = (): ReactNode => {
    const items = [...CLIENTS, ...CLIENTS]

    return (
        <section id='clients' aria-label="Clients" className='border-y border-line bg-white'>
            <Container className='flex flex-col gap-5 py-7 md:flex-row md:items-center md:gap-10'>
                <p className='shrink-0 font-mono text-[11px] uppercase tracking-[0.14em] text-muted-foreground md:w-44'>
                    Trusted by teams at
                </p>

                <div className='marquee min-w-0 flex-1 overflow-hidden'>
                    <ul className='marquee-track flex w-max items-center'>
                        {items.map((client, index) => {
                            const Icon = client.icon

                            return (
                                <li
                                    key={`${client.name}-${index}`}
                                    aria-hidden={index >= CLIENTS.length ? 'true' : undefined}
                                    className='flex shrink-0 items-center gap-2.5 pr-14 text-ink/45 transition-colors duration-300 hover:text-ink'
                                >
                                    <Icon aria-hidden='true' className='size-5' />
                                    <span className='whitespace-nowrap text-lg font-medium tracking-[-0.03em]'>
                                        {client.name}
                                    </span>
                                </li>
                            )
                        })}
                    </ul>
                </div>
            </Container>
        </section>
    )
}
